// Module
var code = "<div class=\"request-access\"> <sb-app-no-access-states id=\"requestAccess\"></sb-app-no-access-states> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/requestAccess/request_access.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;